import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import CSVReader from '../../Components/Clients/CSVReader';
import {
  delClients,
  getModelData,
} from '../../Redux/Actions/modelsDataActions';
import { toggleLoading } from '../../Redux/Actions/Loading';
import axios from 'axios';
import { clearForm } from '../../Redux/Actions/formsActions';
import { toast } from 'react-toastify';

class LeftForm extends Component {
  delClients = () => {
    const { onDelClients, onToggleLoading, model } = this.props;
    onToggleLoading();
    axios
      .delete(`api/v1/${model}`)
      .then(resp => resp.data)
      .then(data => {
        if (data.success) {
          onDelClients();
        }
        onToggleLoading();
      })
      .catch(e => {
        onToggleLoading();
        toast.error(`Impossible de supprimer les travaux`);
      });
  };

  clear = () => {
    const { onClearForm } = this.props;
    onClearForm();
  };

  action = () => {
    const {
      data,
      onToggleLoading,
      onGetModelData,
      onClearForm,
      model,
    } = this.props;

    onToggleLoading();
    if (!data.isEditing) {
      axios
        .post(`api/v1/${model}`, { object: data })
        .then(() => {
          onClearForm();
          onGetModelData(model);
          onToggleLoading();
        })
        .catch(e => {
          onToggleLoading();
          toast.error(`Impossible de créer l'item`);
        });
    } else {
      axios
        .put(`api/v1/${model}/${data.id}`, { object: data })
        .then(() => {
          onClearForm();
          onGetModelData(model);
          onToggleLoading();
        })
        .catch(e => {
          onToggleLoading();
          toast.error(`Impossible de mettre à jour l'item`);
        });
    }
  };

  render() {
    const { title, children, model, data } = this.props;
    const { isEditing } = data;
    return (
      <React.Fragment>
        <div className="left-fixed-new">
          <div className="content-box">
            <h3 className="content-box-header bg-default bold">
              <FontAwesomeIcon icon={faCog} />
              {title}
            </h3>
            <div className="content-box-wrapper">
              {children}
              <div className="button-pane unique">
                {model === 'clients' && (
                  <div className="delete-btn-container">
                    <button
                      onClick={this.delClients}
                      className="btn btn-danger"
                    >
                      SUPPRIMER TOUT
                    </button>
                  </div>
                )}
                <div className="wrap-right">
                  <div className="new-section">
                    <button onClick={this.action} className="btn btn-primary">
                      {isEditing ? 'Modifier' : 'Créer'}
                    </button>
                  </div>
                  <button
                    onClick={this.clear}
                    className="btn btn-default erase-btn"
                  >
                    Effacer
                  </button>
                </div>
              </div>
            </div>
          </div>
          {model === 'clients' && <CSVReader />}
        </div>
        <div className="col-md-4" />
      </React.Fragment>
    );
  }
}

LeftForm.defaultProps = {
  data: {},
};

const mapStateToProps = (state, ownProps) => ({
  data: state.forms[ownProps.model],
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onToggleLoading: () => dispatch(toggleLoading()),
  onDelClients: () => dispatch(delClients()),
  onClearForm: () => dispatch(clearForm(ownProps.model)),
  onGetModelData: data => dispatch(getModelData(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LeftForm);
